import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const CompleteValidation = lazy(() => import('../../container/facilitator/validation/CompleteValidations'));
const PendingValidations = lazy(() => import('../../container/facilitator/validation/PendingValidations'));
const BorrowerValidations = lazy(() => import('../../container/facilitator/validation/BorrowerValidations'));
const ProjectValidations = lazy(() => import('../../container/facilitator/validation/ProjectValidations'));
const ProjectValidationList = lazy(() => import('../../container/borrower/project/ProjectValidationList'));
const ValidationDetails = lazy(() => import('../../container/facilitator/validation/ValidationDetails'));
function PagesRoute() {
  return (
    <Routes>
      <Route path="borrower/:borrowerId" element={<BorrowerValidations />} />
      <Route path="project/:projectId" element={<ProjectValidations />} />
      <Route path=":validationId" element={<ValidationDetails />} />
      <Route path="project/list" element={<ProjectValidationList />} />
      <Route path="pending" element={<PendingValidations />} />
      <Route path="completed" element={<CompleteValidation />} />
    </Routes>
  );
}

export default PagesRoute;
